<template>
  <div>
    <!-- <h2 class="pc_title">我的>采购管理</h2> -->
    <Comments gongxu="xu" />
  </div>
</template>

<script>
import Comments from "../../../../components/pc/comments";
export default {
  components:{
    Comments,
  },
  data(){
    return{

    }
  },
  mounted(){
  },
  

}
</script>

<style scoped>
  .pc_title{
    padding: 20px 30px 0;
    font-size: 24px;
    color: #008baf;
    font-weight: 600;
  }

</style>